(function(angular){
	'use strict';
	
	var planCardObject = {
		templateUrl: [
			'STATIC_BASE_PATH', 
			templateUrlFunction
		],
		bindings: {
			cardTitle: '<',
			includeBars: '<?',
			includeModule: '<?'
		},
		controller: [
			'PlanCardFactory',
			PlanCardStaticFunction
		],
		controllerAs: 'planCardStatic'
	};
	
	angular
		.module('planModule')
		.component('planCardStatic', planCardObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/ria/shared/plans/plan-card-static.html';
	}
	
	function PlanCardStaticFunction(
		PlanCardFactory
	){
		var planCardStatic = this;

		planCardStatic.$onInit = function() {
			planCardStatic.card = PlanCardFactory.getPlanCardData()[planCardStatic.cardTitle];
		};
	}
})(window.angular);